import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export default function EditDocumentClassificationDialog({ open, onClose, onUpdate, initialData, documentDomains }) {
    const [classificationName, setClassificationName] = useState('');
    const [losDoc, setLosDoc] = useState('');
    const [domainId, setDomainId] = useState('');

    const isNameValid = classificationName.trim().length > 0;

    useEffect(() => {
        if (initialData) {
            setClassificationName(initialData.classificationName);
            setLosDoc(initialData.alias || '');
            setDomainId(initialData.documentDomainId); // Ensure your initialData contains documentDomainId
        }
    }, [initialData]);

    const handleSubmit = () => {
        onUpdate({
            classificationId: initialData.classificationId,
            classificationName: classificationName.trim(),
            documentDomainId: domainId,
            alias: losDoc
        });
    };

    return (
        <Dialog open={open} onClose={onClose} PaperProps={{ sx: { width: '600px' } }}>
            <DialogTitle>Edit Classification</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField
                        label="Classification Name"
                        value={classificationName}
                        onChange={(e) => setClassificationName(e.target.value)}
                        fullWidth
                        error={!isNameValid}
                        helperText={!isNameValid ? 'Name is required' : ''}
                    />
                    <TextField
                        label="LOS Doc"
                        value={losDoc}
                        onChange={(e) => setLosDoc(e.target.value)}
                        fullWidth
                    />
                    <FormControl fullWidth>
                        <InputLabel id="edit-domain-select-label">Document Domain</InputLabel>
                        <Select
                            labelId="edit-domain-select-label"
                            value={domainId}
                            label="Document Domain"
                            onChange={(e) => setDomainId(e.target.value)}
                        >
                            {documentDomains.map((domain) => (
                                <MenuItem key={domain.domainId} value={domain.domainId}>
                                    {domain.domainName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={!isNameValid}
                >
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    );
}
